module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "signup"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('menu.signup'),
      "level": 2,
      "font": "oswald",
      "color": "red",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "username",
      "placeholder": _vm.$t('menu.username')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formErrors.has('username')),
      expression: "formErrors.has('username')"
    }],
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.formErrors.first('username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('required|email'),
      expression: "'required|email'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": _vm.$t('menu.mail')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formErrors.has('email')),
      expression: "formErrors.has('email')"
    }],
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.formErrors.first('email')))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('required|confirmed:password-confirm'),
      expression: "'required|confirmed:password-confirm'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "password",
      "id": "signup-password",
      "name": "signup-password",
      "placeholder": _vm.$t('menu.password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "txt",
    attrs: {
      "type": "password",
      "id": "password-confirm",
      "name": "password-confirm",
      "placeholder": _vm.$t('menu.confirmation')
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formErrors.has('signup-password')),
      expression: "formErrors.has('signup-password')"
    }],
    staticClass: "errors"
  }, [_vm._v("\n        " + _vm._s(_vm.formErrors.first('signup-password')) + "\n      ")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('alpha_spaces'),
      expression: "'alpha_spaces'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "text",
      "id": "location",
      "name": "location",
      "placeholder": _vm.$t('menu.location')
    },
    domProps: {
      "value": (_vm.location)
    },
    on: {
      "keyup": _vm.getLocations,
      "blur": _vm.hideAutocomplete,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.location = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.locations.length > 0) ? _c('ul', {
    attrs: {
      "id": "autocomplete"
    }
  }, _vm._l((_vm.locations), function(location) {
    return _c('li', [_vm._v(_vm._s(location.name))])
  })) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    attrs: {
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.language')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "english"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.english')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "french"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.french')))])])]), _vm._v(" "), _c('div', [_c('datepicker', {
    attrs: {
      "input-class": "txt",
      "id": "birthday",
      "name": "birthday",
      "placeholder": _vm.$t('menu.birthday'),
      "language": _vm.$i18n.locale,
      "full-month-name": true
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1), _vm._v(" "), _c('input', {
    staticClass: "custom-btn",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('menu.validate')
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b29d80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Signup.vue
// module id = 275
// module chunks = 0